import React from 'react';

/**
 * Displays messaging about a Discard.
 * Whether a new pack will be automatically shipped or if the patient needs to initiate a
 * recollection and whether a patient-initiated recollection will cost.
 */

export const DiscardDisclaimer = ({ gearOrder, gearReq, accessionDetail }) => {
	if (!accessionDetail?.discardedSpecimen) {
		return null;
	}

	// Discards with a STAR will be re-shipped automatically.
	if (accessionDetail?.issues?.length) {
		return (
			<div>
				<i className="fa fa-info-circle text-info mr-5" aria-hidden="true"></i>A new collection pack will be
				mailed to you for recollection.
			</div>
		);
	}

	// No STAR -> The patient must initiate a recollection.
	let paymentRequired =
		gearOrder?.pitlRecollectionOrderSummary?.gearReqRecollectionMap?.[gearReq.id]?.paymentRequired;
	return (
		<div>
			If you would like to submit new specimens so that testing may be completed, you may request a new collection
			pack
			{paymentRequired && <span> for an additional $40 charge</span>}.
		</div>
	);
};
